import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Azienda} from "../../Admin/models/Azienda";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ApiRestService as ClientiApiRestService} from "../../Admin/_service/api-rest.service";
import {Listino, ProdottoListino} from "../_Models";
import {ApiRestService} from "../api-rest.service";
import {DatePipe} from "@angular/common";
import {ListinoProdottiEditComponent} from "../listino-prodotti-edit/listino-prodotti-edit.component";
import {ListaProdottiComponent} from "../../Prodotti/lista-prodotti/lista-prodotti.component";

@Component({
  selector: 'app-listino-edit',
  templateUrl: './listino-edit.component.html'
})
export class ListinoEditComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Output() Saved = new EventEmitter<boolean>();
  @ViewChild('prodotti')
  private prodotti:  ListaProdottiComponent;
  Fornitori: Azienda[] = [];
  FornitoriSelezionati: Azienda[] = [];
  data: string;
  @Input() listino: Listino = new Listino();
  clientiDropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'nominativo'
  };
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private ngbModal: NgbModal,
    private clientiApiRest : ClientiApiRestService,
    private apiRestService : ApiRestService,
    private datepipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.clientiApiRest.getListaAziende({ruolo: "F", page:0, size: 10}).subscribe(data=> this.Fornitori = data?.data);
    if(this.listino.id){
      this.apiRestService.ProdottiListinoGet(this.listino).subscribe(data => {
        this.listino = data?.data;
        this.FornitoriSelezionati = [this.listino.fornitoreObject];
        this.listino.data = this.datepipe.transform(new Date(this.listino.data), 'yyyy-MM-dd')
      })
    }
  }
  GetData(){
    this.listino.id_fornitore = this.FornitoriSelezionati[0]?.id;
    return this.listino;
  }
  save() {
    if(this.listino.id){
      this.apiRestService.ProdottiListinoUpdate(this.GetData()).subscribe(()=> {
        this.Saved.emit(true);
        this.close();
      })
    } else {
      this.apiRestService.ProdottiListinoAdd(this.GetData()).subscribe(()=> {
        this.Saved.emit(true);
        this.close();
      })
    }
  }
  close() {
    this.ngbActiveModal.dismiss();
  }

  AddProdotto() {
    let modale = this.ngbModal.open(ListinoProdottiEditComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListinoProdottiEditComponent>modale.componentInstance).isModal = true;
    (<ListinoProdottiEditComponent>modale.componentInstance).prodotto = new ProdottoListino(this.listino?.id);
    (<ListinoProdottiEditComponent>modale.componentInstance).Saved.subscribe(()=> this.prodotti.refreshTable(1));
  }

  UpdateProdotto(value) {
    let modale = this.ngbModal.open(ListinoProdottiEditComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListinoProdottiEditComponent>modale.componentInstance).isModal = true;
    (<ListinoProdottiEditComponent>modale.componentInstance).prodotto = value;
    (<ListinoProdottiEditComponent>modale.componentInstance).Saved.subscribe(()=> this.prodotti.refreshTable(1));
  }
  DeleteProdotto(value) {
    this.apiRestService.ProdottiListinoProdottiDelete(value).subscribe(()=> this.prodotti.refreshTable(1))
  }
  RestoreProdotto(value) {
    this.apiRestService.ProdottiListinoProdottiRestore(value).subscribe(()=> this.prodotti.refreshTable(1))
  }

}
